export default __webpack_public_path__ + "static/media/favorite.9123aa28.svg";